import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=1c371766&scoped=true&"
var script = {}
import style0 from "./TheHeader.vue?vue&type=style&index=0&id=1c371766&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c371766",
  null
  
)

export default component.exports